
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { ArrowUp, Users, DollarSign, Eye } from 'lucide-react';

const data = [
  {
    name: 'Jan',
    views: 1200,
  },
  {
    name: 'Feb',
    views: 1900,
  },
  {
    name: 'Mar',
    views: 1600,
  },
  {
    name: 'Apr',
    views: 2200,
  },
  {
    name: 'May',
    views: 2800,
  },
  {
    name: 'Jun',
    views: 2600,
  },
  {
    name: 'Jul',
    views: 3200,
  },
];

const DashboardMetrics = () => {
  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card className="dark:bg-gray-800 dark:text-gray-100">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Views</CardTitle>
            <Eye className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">15,432</div>
            <p className="text-xs text-muted-foreground">
              <span className="text-green-500 inline-flex items-center">
                <ArrowUp className="h-3 w-3 mr-1" />+12.5%
              </span>{" "}
              from last month
            </p>
          </CardContent>
        </Card>
        <Card className="dark:bg-gray-800 dark:text-gray-100">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Subscribers</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">243</div>
            <p className="text-xs text-muted-foreground">
              <span className="text-green-500 inline-flex items-center">
                <ArrowUp className="h-3 w-3 mr-1" />+8.2%
              </span>{" "}
              from last month
            </p>
          </CardContent>
        </Card>
        <Card className="dark:bg-gray-800 dark:text-gray-100">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Earnings This Month</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">$1,254.32</div>
            <p className="text-xs text-muted-foreground">
              <span className="text-green-500 inline-flex items-center">
                <ArrowUp className="h-3 w-3 mr-1" />+18.7%
              </span>{" "}
              from last month
            </p>
          </CardContent>
        </Card>
      </div>
      
      <Card className="col-span-4 dark:bg-gray-800 dark:text-gray-100">
        <CardHeader>
          <CardTitle>Audience Growth</CardTitle>
          <CardDescription>
            Article views over the past 7 months
          </CardDescription>
        </CardHeader>
        <CardContent className="pl-2">
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data}>
              <XAxis
                dataKey="name"
                stroke="#888888"
                fontSize={12}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="#888888"
                fontSize={12}
                tickLine={false}
                axisLine={false}
                tickFormatter={(value) => `${value}`}
              />
              <Bar
                dataKey="views"
                fill="#F97316"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardMetrics;
